import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import FloatingWhatsApp from "./FloatingWhatsApp";
import { UIOverlayProvider } from "@/lib/uiOverlay";

export default function Layout() {
  return (
    <UIOverlayProvider>
      <div className="min-h-screen flex flex-col bg-[#0B0F17]">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <FloatingWhatsApp />
      </div>
    </UIOverlayProvider>
  );
}
